import { SyntheticEvent, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { CircularProgress } from '@mui/material';
import { useUserDetails } from 'api/useUserDetails';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';

import PageTopBar from 'components/Topbar/PageTopBar';

import './style.scss';

enum EProfileState {
  PERSONAL = 'personal',
  PASSWORD = 'password'
}

const ProfileView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname.split('/')[4];
  const [tab, setTab] = useState(currentTab);
  const { isLoading } = useUserDetails();

  useEffect(() => {
    setTab(location.pathname.split('/').pop() || '');
  }, []);

  const tabs = [
    { label: 'Personal Info', value: EProfileState.PERSONAL },
    { label: 'Password', value: EProfileState.PASSWORD }
  ];

  const handleTabChange = (event: SyntheticEvent, newValue: EProfileState) => {
    setTab(newValue);
    const newPath = `/profile/${newValue}`;
    navigate(newPath);
  };

  if (isLoading)
    return (
      <CircularProgress
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: '60px',
          width: '60px'
        }}
      />
    );

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Profile" />}
      handleTabChange={handleTabChange}
      activeTabVal={tab}
    />
  );
};

export default ProfileView;
